import { render, staticRenderFns } from "./AkPrice.vue?vue&type=template&id=d4dc99be&"
import script from "./AkPrice.vue?vue&type=script&lang=js&"
export * from "./AkPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/optiek-dominiek-blueprints/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4dc99be')) {
      api.createRecord('d4dc99be', component.options)
    } else {
      api.reload('d4dc99be', component.options)
    }
    module.hot.accept("./AkPrice.vue?vue&type=template&id=d4dc99be&", function () {
      api.rerender('d4dc99be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkPrice.vue"
export default component.exports